import React from 'react';
import cx from 'classnames';

import SubCategoryListView from './SubCategoryListView';
import Button from '../../../../components/Button';
import './SubCategoryDetail.scss';

const SubCategoryDetailView = ({ onAddRow, onResetFilter, disabledAction, ...res }) => {
  return (
    <>
      <div className="main-title">2차(하위) 카테고리 정보</div>
      <div className="sub-category-detail-wrap">
        <div className="sub-category-detail-btn-wrap">
          <Button
            className="sub-category-create-btn"
            isRadius
            color="primary"
            text="2차(하위) 카테고리 생성"
            disabled={disabledAction}
            onClick={onAddRow}
          />
          <Button
            className={cx('sub-category-reset-filter-btn', 'right')}
            isRadius
            color="primary"
            text="필터 초기화"
            onClick={onResetFilter}
          />
        </div>
        <SubCategoryListView {...res} disabledAction={disabledAction} />
      </div>
    </>
  );
};

export default SubCategoryDetailView;
